export const EVENT_COLORS = [
  'border-state-yellow bg-state-yellow_bg',
  'border-state-green bg-state-green_bg',
  'border-state-red bg-state-red_bg',
  'border-[#9743CA] bg-[#EEE2F5]',
  'border-state-blue bg-state-blue_bg',
  'border-state-gray bg-state-gray_bg',
];
